import { render, staticRenderFns } from "./partner.vue?vue&type=template&id=2dc5d792&scoped=true"
var script = {}
import style0 from "./partner.vue?vue&type=style&index=0&id=2dc5d792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc5d792",
  null
  
)

export default component.exports